import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

import confMang from "../../Assets/Images/conference_management.png";
import bookLaunch from "../../Assets/Images/book_launch_event.png";
import corpoEvent from "../../Assets/Images/corporate_event.png";
import exhibition from "../../Assets/Images/exhibitions_expos.png";

const images = [confMang, bookLaunch, corpoEvent, exhibition];

const blocksContent = [
  {
    title: "Conference Management",
    description:
      "We specialize in organizing conferences that bring industry leaders, professionals, and visionaries together. From planning to execution, we ensure seamless coordination, innovative setups, and engaging experiences that leave a lasting impression.",
  },
  {
    title: "Book Launch Events",
    description:
      "A book launch is more than just an event; it's a celebration of ideas, creativity, and hard work. We craft sophisticated and engaging book publication events that create buzz and captivate audiences, ensuring your work gets the attention it deserves.Let’s bring your story to life!",
  },
  {
    title: "Corporate Events",
    description:
      "From award ceremonies to annual meets, we design corporate events that reflect your brand’s values and vision. As a top corporate event management company, we provide meticulous planning and flawless execution, we create experiences that inspire, connect, and leave a strong brand impression.",
  },
  {
    title: "Exhibitions & Expos",
    description:
      "We organize dynamic expos and exhibitions that provide businesses and innovators a powerful platform to showcase their products and engage audiences.",
  },
];

const ExclusiveHover = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const containerStyle = {
    height: "80vh",
    backgroundImage: `url(${images[hoveredIndex] || images[0]})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    transition: "background-image 1s ease-in-out",
  };

  const blockStyle = (isHovered) => ({
    height: "100%",
    display: "flex",
    alignItems: isHovered ? "center" : "flex-end",
    justifyContent: "center",
    textAlign: "center",
    cursor: "pointer",
    border: "3px solid white",
    position: "relative",
    backgroundColor: isHovered ? "rgba(255, 255, 255, 0.7)" : "rgba(0,0,0,0.5)",
    transition: "all 0.9s ease-in-out",
    color: isHovered ? "black" : "white",
  });

  const getContentWrapperStyle = (isHovered) => ({
    position: "absolute",
    left: "50%",
    bottom: isHovered ? "50%" : "20px",
    textAlign: "center",
    transform: isHovered ? "translate(-50%, 50%)" : "translateX(-50%)",
    transition: "all 0.9s ease-in-out",
    width: "80%",
  });

  const titleStyle = {
    fontFamily: "Marcellus",
    fontWeight: 400,
    fontSize: "24px",
    paddingBottom: "10px",
  };

  const descStyle = {
    fontFamily: "Marcellus",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "26px",
  };

  return (
    <>
      {/* Desktop */}
      <div className="container-fluid d-none d-lg-block bg-white">
        <div style={containerStyle}>
          <div className="row h-100">
            {blocksContent.map((content, index) => {
              const isHovered = hoveredIndex === index;
              return (
                <div
                  key={index}
                  className="col"
                  style={blockStyle(isHovered)}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}>
                  <div style={getContentWrapperStyle(isHovered)}>
                    <div style={titleStyle}>{content.title}</div>
                    {isHovered && (
                      <div style={descStyle}>{content.description}</div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Mobile Swiper */}
      <div className="container d-block d-lg-none mt-3">
        <Swiper spaceBetween={16} slidesPerView={1}>
          {blocksContent.map((content, index) => (
            <SwiperSlide key={index}>
              <div
                style={{
                  backgroundImage: `url(${images[index]})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "500px",
                  position: "relative",
                  overflow: "hidden",
                }}>
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.4)",
                    zIndex: 1,
                  }}></div>

                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    width: "100%",
                    color: "white",
                    padding: "20px",
                    zIndex: 2,
                  }}>
                  <div style={{ fontWeight: "bold", fontSize: "24px" }}>
                    {content.title}
                  </div>
                  <div style={{ fontSize: "16px", marginTop: "18px" }}>
                    {content.description}
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

function HomeExclusive() {
  return (
    <div>
      <SectionHeading
        secTitle="  Exclusively yours"
        secIndex="Personalize Your Event, Experience Professionalism, Embrace Perfection."
      />
      <ExclusiveHover />
    </div>
  );
}

export default HomeExclusive;
